import {ErrorsRanked} from '../errors/ErrorsRanked'
import {ModeSettingEnum} from '@colonist/game-base-types'
import {GameModeDataController} from '@colonist/shared-types'
import {UserItems} from '../store/UserItems'
import {ABTestCategory} from '../ABTestTypes'

const CK_1_FREE_GAME_COUNT = 1
const CK_3_FREE_GAME_COUNT = 3
const CK_5_FREE_GAME_COUNT = 5

export function userHasAccessToRankedCitiesAndKnights(userItems: UserItems | undefined, ckTotalGameCount: number | undefined, abTestGroups: Partial<Record<ABTestCategory, string>>, freePlayUntil: Date | undefined): boolean {
    if(userHasNormalAccessToCitiesAndKnights(userItems)) return true
    if(userHasFreeCitiesAndKnightsGame(abTestGroups, ckTotalGameCount)) return true
    return false
}

export function userHasNormalAccessToCitiesAndKnights(userItems: UserItems | undefined): boolean {
    if(userItems == undefined) return false
    const citiesAndKnightsData = GameModeDataController.getModeDataForMode(ModeSettingEnum.CitiesAndKnights4P)
    if(citiesAndKnightsData == undefined) throw new ErrorsRanked.ServerErrorCitiesAndKnights()

    if(userItems.membership != undefined) return true
    if(userItems.hasAccessToPremiumMode(citiesAndKnightsData)) return true
    return false
}

export function userHasFreeCitiesAndKnightsGame(abTestGroups: Partial<Record<ABTestCategory, string>>, ckTotalGameCount: number | undefined): boolean {
    if(ckTotalGameCount == undefined) return false
    if(ckTotalGameCount < getFreeGameCount(abTestGroups)) return true
    return false
}

export function getFreeGameCount(abTestGroups: Partial<Record<ABTestCategory, string>>): number {
    if(abTestGroups['CK_MONETIZATION_FREE_PLAYS'] == 'CK_MONETIZATION_1_FREE_PLAY') return CK_1_FREE_GAME_COUNT
    if(abTestGroups['CK_MONETIZATION_FREE_PLAYS'] == 'CK_MONETIZATION_3_FREE_PLAYS') return CK_3_FREE_GAME_COUNT
    if(abTestGroups['CK_MONETIZATION_FREE_PLAYS'] == 'CK_MONETIZATION_5_FREE_PLAYS') return CK_5_FREE_GAME_COUNT
    return 0
}
